import React from "react";
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaClock } from "react-icons/fa";
import "../Contact/Reach.css";

const Reach = () => {
  return (
    <div className="reach-container-rr">
      <div className="reach-form-rr">
        <h2 className="form-heading-rr">Contact Form</h2>
        <form className="form-rr">
          <div className="input-group-rr">
            <input
              className="input-first-name-rr"
              type="text"
              placeholder="First Name"
              required
            />
            <input
              className="input-last-name-rr"
              type="text"
              placeholder="Last Name"
              required
            />
          </div>
          <div className="input-group-rr">
            <input
              className="input-email-rr"
              type="email"
              placeholder="Your Email"
              required
            />
            <input
              className="input-phone-rr"
              type="tel"
              placeholder="Your Phone"
              required
            />
          </div>
          <div className="input-group-rr">
          <input
            className="input-address-rr"
            type="text"
            placeholder="Address"
            required
          />
            <select className="dropdown-case-type-rr" required>
            <option value="" disabled selected>
               Service Type
            </option>
            <option value="legal">Tax Advisory</option>
            <option value="financial">Financial Planning</option>
            <option value="personal">Audit Services</option>
            <option value="other">Consulting</option>
          </select>
            </div>
          <textarea
            className="textarea-message-rr"
            placeholder="Your Message"
            required
          ></textarea>
        
          <button className="submit-button-rr" type="submit">
            Send Your Requirements
          </button>
        </form>
      </div>
      <div className="reach-info-rr">
        <h2 className="info-heading-rr">Contact Info</h2>
        <ul className="info-list-rr">
          <li className="info-item-rr">
            <FaMapMarkerAlt className="icon-rr" />
            <div className="text-d-rr">
            <p className="info-text-rr">Address: </p>
            <p className="info-text-rrr">132 New York Street NY</p>
            </div>
          </li>
          <li className="info-item-rr">
            <FaPhoneAlt className="icon-rr" />
            <div className="text-d-rr">
            <p className="info-text-rr">Phone: </p>
            <p className="info-text-rrr">01546 875 656, 01546 985 989</p>
            </div>
            
          </li>
          <li className="info-item-rr">
            <FaEnvelope className="icon-rr" />
            <div className="text-d-rr">
            <p className="info-text-rr">Email: </p>
            <p className="info-text-rrr">info@example.com</p>
            </div>
            
          </li>
          <li className="info-item-rr">
            <FaClock className="icon-rr" />
            <div className="text-d-rr">
            <p className="info-text-rr">Working Hours: </p>
            <p className="info-text-rrr">Mon to Sat – 9:00am to 6:00pm</p>
            </div>
           
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Reach;
